// File: reactnodehelloworld/frontend/src/pages/Services.js
import React, { Component } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import './services.css';



function Services() {
  return (
    <div className="services-container">
        <Sidebar />
        <div className="services-content">
        <header className="App-header">
      <h2>Our Services</h2>
      <p>Welcome to the services page. Here we offer various services to cater to your needs.</p>
      </header >
      </div>
    </div>
  );
}

export default Services;
